module.exports = __webpack_public_path__ + "static/media/ic_sec_others.cf830f88.svg";